import { createContext, useContext } from 'react';
import { JumbotronTypes } from '../jumbotronTypes';

export const defaultContext: JumbotronTypes.TJumbotronContext = {
  locationData: [
    {
      facilityName: '',
      locationName: '',
      address: [{ label: '', data: '', link: '' }],
      priceSection: {
        icon: { iconClassName: 'AiFillMail', size: '', color: '' },
        text: '',
        price: {
          icon: { iconClassName: 'AiFillMail', size: '', color: '' },
          unitStartingPrice: 1,
        },
      },
      reviewRating: {
        maxRating: 5,
        rating: 3.2,
        size: 16,
        totalReviews: 7,
      },
      facilityHours: {
        gateHrs: {
          weekdays: { open: '0300', close: '2359' },
          weekends: { open: '0300', close: '2359' },
        },
        officeHrs: {
          weekdays: { open: '0800', close: '1700' },
          weekends: { open: '0900', close: '1300' },
        },
      },
      addressText: '',
    },
  ],
  selectedLocation: {
    facilityName: '',
    locationName: '',
    address: [],
    contactNumber: undefined,
    emailAddress: undefined,
    reviewRating: {
      maxRating: 5,
      rating: 3.2,
      size: 16,
      totalReviews: 7,
    },
    reviewLink: undefined,
    priceSection: {
      icon: {
        iconClassName: 'AiFillMail',
        size: '',
        color: '',
      },
      text: '',
      price: {
        icon: {
          iconClassName: 'AiFillMail',
          size: '',
          color: '',
        },
        unitStartingPrice: 0,
      },
    },
    facilityHours: {
      officeHrs: {
        allDays: undefined,
        weekends: undefined,
        weekdays: undefined,
        customDays: undefined,
      },
      gateHrs: {
        allDays: undefined,
        weekends: undefined,
        weekdays: undefined,
        customDays: undefined,
      },
    },
    addressText: '',
    buttonText: undefined,
  },
  variantType: 'single',
  jumbotron_subtitle: {
    description: ''
  },
};

export const JumbotronContext = createContext<JumbotronTypes.TJumbotronContext>(
  defaultContext
);
export const useJumbotronContext = () => useContext(JumbotronContext);
